import type { ChangeEventHandler } from 'react';
import { useState } from 'react';
import { SearchSvg } from 'components/svg/search-svg';
import { CloseSvg } from 'components/svg/close-svg';
import { useDebounce } from 'hooks/use-debounce';
import { Loader } from 'components/loader';
import { useSearchParams } from 'react-router-dom';
import {
  CloseIcon,
  SearchIcon,
  SearchInput,
  SearchStyled,
  SearchWrapper
} from './style';

interface SearchProps {
  setTerm: (value: string) => void;
  isLoading: boolean;
}

export const Search = ({ setTerm, isLoading }: SearchProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [value, setValue] = useState('');
  const debounce = useDebounce((value: string) => {
    searchParams.delete('page');
    setSearchParams(searchParams);
    setTerm(value);
  }, 500);

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const { value } = e.target;
    setValue(value);
    debounce(value);
  };

  const handleClose = () => {
    setValue('');
    setTerm('');
    searchParams.delete('page');
    setSearchParams(searchParams);
  };

  return (
    <SearchWrapper>
      <SearchStyled $isActive={!!value}>
        <SearchIcon>
          <SearchSvg />
        </SearchIcon>
        <SearchInput
          value={value}
          onChange={handleChange}
          placeholder="Пошук"
        />
        {value ? (
          isLoading ? (
            <Loader />
          ) : (
            <CloseIcon onClick={handleClose}>
              <CloseSvg />
            </CloseIcon>
          )
        ) : (
          ''
        )}
      </SearchStyled>
    </SearchWrapper>
  );
};
